<mat-card>
  <app-card-header
    [title]="presentacion.label"
    [icono]="presentacion.icono"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Duración (para eventos múltiples) -->
    @if (data.evento.totalEventos > 1) {
      <app-content-card title="Duración del estado" icon="schedule">
        <div class="ded-datos">
          <div class="ded-dato">
            <span class="ded-etiqueta">Desde</span>
            @if (data?.evento?.timestampInicio) {
              <span class="ded-valor">
                {{ data?.evento?.timestampInicio | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            } @else {
              <span class="no-info">Sin fecha</span>
            }
          </div>
          <div class="ded-dato">
            <span class="ded-etiqueta">Hasta</span>
            @if (data?.evento?.timestampFin) {
              <span class="ded-valor">
                {{ data?.evento?.timestampFin | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            } @else {
              <span class="no-info">Sin fecha</span>
            }
          </div>
        </div>
      </app-content-card>
    }

    <!-- Información general -->
    @if (
      valores?.observaciones ||
      valores?.diagnostico ||
      valores?.motivoCancelacion ||
      valores?.motivoReasignacion
    ) {
      <app-content-card title="Información general" icon="info">
        <div class="ded-datos ded-una-columna">
          @if (valores?.observaciones) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Observaciones</span>
              <span class="ded-valor ded-texto">
                {{ valores?.observaciones }}
              </span>
            </div>
          }
          @if (valores?.diagnostico) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Diagnóstico</span>
              <span class="ded-valor ded-texto">
                {{ valores?.diagnostico }}
              </span>
            </div>
          }
          @if (valores?.motivoCancelacion) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Motivo de cancelación</span>
              <span class="ded-valor ded-texto">
                {{ valores?.motivoCancelacion }}
              </span>
            </div>
          }
          @if (valores?.motivoReasignacion) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Motivo de reasignación</span>
              <span class="ded-valor ded-texto">
                {{ valores?.motivoReasignacion }}
              </span>
            </div>
          }
        </div>
      </app-content-card>
    }

    <!-- Ubicación con mapa -->
    @if (tieneUbicacion) {
      <app-content-card title="Ubicación" icon="place">
        <div class="ded-datos ded-una-columna">
          <div class="ded-dato">
            <span class="ded-etiqueta">Dirección</span>
            @if (valores?.direccionActual) {
              <span class="ded-valor">{{ valores?.direccionActual }}</span>
            } @else {
              <span class="no-info">Sin dirección</span>
            }
          </div>
        </div>

        <div class="mapa-container">
          <app-mapa-facil-v2
            [center]="coordenadas"
            [zoom]="18"
            [showMapSelector]="false"
            mapId="mapa-detalles-evento"
            (mapReady)="onMapReady($event)"
          ></app-mapa-facil-v2>
        </div>
      </app-content-card>
    }

    <!-- Reporte inicial -->
    @if (data?.evento?.eventosPrimario) {
      <app-content-card title="Reporte inicial" icon="description">
        <div class="ded-datos">
          <div class="ded-dato">
            <span class="ded-etiqueta">Hora</span>
            @if (data?.evento?.eventosPrimario?.fechaCreacion) {
              <span class="ded-valor">
                {{
                  data?.evento?.eventosPrimario?.fechaCreacion
                    | date: 'dd/MM/yyyy HH:mm'
                }}
              </span>
            } @else {
              <span class="no-info">Sin fecha</span>
            }
          </div>
          @if (
            data?.evento?.eventosPrimario?.detallesEmergencias?.movilAsignado
          ) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Móvil</span>
              <span class="ded-valor">
                {{
                  data?.evento?.eventosPrimario?.detallesEmergencias
                    ?.movilAsignado?.identificacion
                }}
              </span>
            </div>
          }
          @if (data?.evento?.eventosPrimario?.detallesEmergencias?.chofer) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Chofer</span>
              <span class="ded-valor">
                {{
                  data?.evento?.eventosPrimario?.detallesEmergencias?.chofer
                    ?.datosPersonales?.nombre ||
                    data?.evento?.eventosPrimario?.detallesEmergencias?.chofer
                      ?.usuario
                }}
              </span>
            </div>
          }
          @if (data?.evento?.eventosPrimario?.detallesEmergencias?.hospital) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Hospital</span>
              <span class="ded-valor">
                {{
                  data?.evento?.eventosPrimario?.detallesEmergencias?.hospital
                    ?.identificacion
                }}
              </span>
            </div>
          }
        </div>
      </app-content-card>
    }

    <!-- Reportes siguientes -->
    @if (data?.evento?.eventosSecundarios?.length) {
      <app-content-card
        [title]="
          'Reportes siguientes (' +
          data?.evento?.eventosSecundarios.length +
          ')'
        "
        icon="list"
      >
        <div class="ded-chips">
          @for (e of data?.evento?.eventosSecundarios; track e) {
            <span class="ded-chip">
              <mat-icon>access_time</mat-icon>
              {{ e?.fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          }
        </div>
      </app-content-card>
    }

    <!-- Personal de salud -->
    @if (
      data?.evento?.detallesEmergencias?.medicos?.length ||
      data?.evento?.detallesEmergencias?.enfermeros?.length
    ) {
      <app-content-card title="Personal de salud" icon="local_hospital">
        <div class="ded-datos ded-una-columna">
          @if (data?.evento?.detallesEmergencias?.medicos?.length) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Médicos</span>
              <div class="ded-chips">
                @for (
                  m of data?.evento?.detallesEmergencias?.medicos;
                  track m
                ) {
                  <span class="ded-chip">
                    <mat-icon>person</mat-icon>
                    {{ m.nombre }}
                  </span>
                }
              </div>
            </div>
          }
          @if (data?.evento?.detallesEmergencias?.enfermeros?.length) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Enfermeros</span>
              <div class="ded-chips">
                @for (
                  e of data?.evento?.detallesEmergencias?.enfermeros;
                  track e
                ) {
                  <span class="ded-chip">
                    <mat-icon>person</mat-icon>
                    {{ e.nombre }}
                  </span>
                }
              </div>
            </div>
          }
        </div>
      </app-content-card>
    }

    <!-- Responsabilidades -->
    @if (
      data?.evento?.detallesEmergencias?.usuarioResponsable ||
      data?.evento?.detallesEmergencias?.centroDeAtencion
    ) {
      <app-content-card title="Responsabilidades" icon="account_circle">
        <div class="ded-datos">
          @if (data?.evento?.detallesEmergencias?.usuarioResponsable) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Usuario responsable</span>
              <span class="ded-valor">
                {{
                  data?.evento?.detallesEmergencias?.usuarioResponsable
                    ?.datosPersonales?.nombre ||
                    data?.evento?.detallesEmergencias?.usuarioResponsable
                      ?.usuario
                }}
              </span>
            </div>
          }
          @if (data?.evento?.detallesEmergencias?.centroDeAtencion) {
            <div class="ded-dato">
              <span class="ded-etiqueta">Base de operaciones</span>
              <span class="ded-valor">
                {{
                  data?.evento?.detallesEmergencias?.centroDeAtencion
                    ?.identificacion
                }}
              </span>
            </div>
          }
        </div>
      </app-content-card>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">Cerrar</button>
  </mat-card-actions>
</mat-card>
